import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ADDON_URL, CROSS_SELL_URL, CROSS_SELL_URL_ENCRYPT, ADDON_URL_ENCRYPT } from '../config/app-settings.config';
import { EncrDecrService } from './encr-decr-service.service';

@Injectable({
  providedIn: 'root'
})
export class AddOnService {

  constructor(private http: HttpClient, private encryptDecService:EncrDecrService) { }
  tokenVal:any = sessionStorage.getItem('jwt');
  s24AccessToken = sessionStorage.getItem("s24_access_token");
  s24TokenExpiryTime = sessionStorage.getItem("s24_expiry_time");

  addAddon(requestBody) {
    let httpOptions: any;
    if (this.s24AccessToken && this.s24TokenExpiryTime) {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json",
          "access_token": this.s24AccessToken,
          "expiry_time": this.s24TokenExpiryTime
        }),
        observe: 'response'
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json"
        }),
        observe: 'response'
      };
    }
    requestBody= ADDON_URL_ENCRYPT ? this.encryptDecService.set(requestBody): requestBody;
    return this.http.post(`${ADDON_URL}`, requestBody, httpOptions)
  }

  setCrossSellFlag(requestBody) {
    let httpOptions: any;
    if (this.s24AccessToken && this.s24TokenExpiryTime) {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json",
          "access_token": this.s24AccessToken,
          "expiry_time": this.s24TokenExpiryTime
        }),
        observe: 'response'
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json"
        }),
        observe: 'response'
      };
    }
    requestBody = CROSS_SELL_URL_ENCRYPT ? this.encryptDecService.set(requestBody): requestBody;
    return this.http.post(`${CROSS_SELL_URL}`, requestBody, httpOptions)
  }

}
